var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M0 0L0 1000L1000 1000L1000 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M493 142L493 143L497 143L493 142M474 143L474 144L478 144L474 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M478 143L478 144L481 144L478 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M481 143L481 144L484 144L481 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M442 603C482.366 626.56 524.815 622.147 566 605C568.021 628.14 580.138 652.335 587.91 674C591.435 683.828 593.424 694.917 604 699.811C619.872 707.156 635.205 694.949 648 687.118C655.826 682.329 664.363 679.245 672 673.975C691.517 660.505 707.407 641.816 718.691 621C738.723 584.049 745.26 543.323 748.089 502C754.318 411.045 734.748 303.28 677.338 230C665.509 214.901 650.926 200.613 634 191.312C619.376 183.275 603.25 179.21 588 172.576C576.735 167.675 567.697 160.005 557 154.402C547.711 149.537 536.238 147.428 526 145.615C441.238 130.606 341.84 176.763 299.862 252C273.031 300.089 265.666 357.803 268.039 412C269.138 437.088 273.642 461.718 271.91 487C269.995 514.966 262.514 542.458 251.139 568C247.891 575.293 243.925 582.18 239.797 589C238.086 591.826 234.853 595.47 236.161 599C240.409 610.461 260.57 622.258 270 629.575C302.587 654.86 339.876 673.367 381 678.286C393.104 679.733 404.164 678.19 416 675.576C420.02 674.688 426.063 674.214 429.239 671.411C445.787 656.812 442 622.478 442 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M505 143L505 144L509 144L505 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M509 143L509 144L512 144L509 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M512 143L512 144L515 144L512 143M466.667 144.333L467.333 144.667L466.667 144.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M468.667 144.333L469.333 144.667L468.667 144.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M470.667 144.333L471.333 144.667L470.667 144.333M517.667 144.333L518.333 144.667L517.667 144.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M519.667 144.333L520.333 144.667L519.667 144.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M521.667 144.333L522.333 144.667L521.667 144.333M459.667 145.333L460.333 145.667L459.667 145.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M461 145L462 146L461 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M462.667 145.333L463.333 145.667L462.667 145.333M525 145L526 146L525 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M526 145L527 146L526 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M527.667 145.333L528.333 145.667L527.667 145.333M454 146L455 147L454 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M455 146L456 147L455 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M456.667 146.333L457.333 146.667L456.667 146.333M530 146L531 147L530 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M531 146L532 147L531 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M532.667 146.333L533.333 146.667L532.667 146.333M449 147L450 148L449 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M450 147L451 148L450 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M451 147L452 148L451 147M535 147L536 148L535 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M536 147L537 148L536 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M537 147L538 148L537 147M444.667 148.333L445.333 148.667L444.667 148.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M446 148L447 149L446 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M539 148L540 149L539 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M540 148L541 149L540 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M541 148L542 149L541 148M440 149L441 150L440 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M441 149L442 150L441 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M442 149L443 150L442 149M543 149L544 150L543 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M544.667 149.333L545.333 149.667L544.667 149.333M436 150L437 151L436 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M437 150L438 151L437 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M438 150L439 151L438 150M546 150L547 151L546 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M547 150L548 151L547 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M548 150L549 151L548 150M433 151L434 152L433 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M434 151L435 152L434 151M549 151L550 152L549 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M550 151L551 152L550 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M429 152L430 153L429 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M430 152L431 153L430 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M431 152L432 153L431 152M552 152L553 153L552 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M553 152L554 153L553 152M426 153L427 154L426 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M427 153L428 154L427 153M555 153L556 154L555 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M556 153L557 154L556 153M423 154L424 155L423 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M424 154L425 155L424 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M557 154L558 155L557 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M558 154L559 155L558 154M420 155L421 156L420 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M421 155L422 156L421 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M559 155L560 156L559 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M417 156L418 157L417 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M418 156L419 157L418 156M560 156L561 157L560 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M414 157L415 158L414 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M415 157L416 158L415 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M561 157L562 158L561 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M412 158L413 159L412 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M413 158L414 159L413 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M563 158L564 159L563 158M409 159L410 160L409 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M410 159L411 160L410 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M564 159L565 160L564 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M406 160L407 161L406 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M407 160L408 161L407 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M565 160L566 161L565 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M404 161L405 162L404 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M405 161L406 162L405 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M567 161L568 162L567 161M402 162L403 163L402 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M403 162L404 163L403 162M568 162L569 163L568 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M569 162L570 163L569 162M400 163L401 164L400 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M570 163L571 164L570 163M398 164L399 165L398 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M571 164L572 165L571 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M572 164L573 165L572 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M396 165L397 166L396 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M573 165L574 166L573 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M574 165L575 166L574 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M394 166L395 167L394 166M575 166L576 167L575 166M392 167L393 168L392 167M577 167L578 168L577 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M390 168L391 169L390 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M579 168L580 169L579 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M388 169L389 170L388 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M581 169L582 170L581 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M386 170L387 171L386 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M387 170L388 171L387 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M583 170L584 171L583 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M584 170L585 171L584 170M384 171L385 172L384 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M385 171L386 172L385 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M585 171L586 172L585 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M586 171L587 172L586 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M383 172L384 173L383 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M587 172L588 173L587 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M588 172L589 173L588 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M381 173L382 174L381 173M590 173L591 174L590 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M379 174L380 175L379 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M592 174L593 175L592 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593 174L594 175L593 174M377 175L378 176L377 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M378 175L379 176L378 175M594 175L595 176L594 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M595 175L596 176L595 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M376 176L377 177L376 176M597 176L598 177L597 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M598 176L599 177L598 176M374 177L375 178L374 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M599 177L600 178L599 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M600 177L601 178L600 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M373 178L374 179L373 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M602 178L603 179L602 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M603 178L604 179L603 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M371 179L372 180L371 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M604 179L605 180L604 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M605 179L606 180L605 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M606 179L607 180L606 179M369 180L370 181L369 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 180L371 181L370 180M608 180L609 181L608 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M609 180L610 181L609 180M368 181L369 182L368 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M611 181L612 182L611 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M612 181L613 182L612 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M613 181L614 182L613 181M366 182L367 183L366 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M367 182L368 183L367 182M614 182L615 183L614 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M615 182L616 183L615 182M365 183L366 184L365 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M617 183L618 184L617 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M618 183L619 184L618 183M363 184L364 185L363 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M364 184L365 185L364 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M620 184L621 185L620 184M362 185L363 186L362 185M622 185L623 186L622 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 185L624 186L623 185M360 186L361 187L360 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M361 186L362 187L361 186M624 186L625 187L624 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M625 186L626 187L625 186M359 187L360 188L359 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M626 187L627 188L626 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M627 187L628 188L627 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M358 188L359 189L358 188M628 188L629 189L628 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M629 188L630 189L629 188M356 189L357 190L356 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M630 189L631 190L630 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M631 189L632 190L631 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M355 190L356 191L355 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M632 190L633 191L632 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 190L634 191L633 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M354 191L355 192L354 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M634 191L635 192L634 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M352 192L353 193L352 192M636 192L637 193L636 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M351 193L352 194L351 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M637 193L638 194L637 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M638 193L639 194L638 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M350 194L351 195L350 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M639 194L640 195L639 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M349 195L350 196L349 195M640 195L641 196L640 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M641 195L642 196L641 195M347 196L348 197L347 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M642 196L643 197L642 196M346 197L347 198L346 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M643 197L644 198L643 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M345 198L346 199L345 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M645 198L646 199L645 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M344 199L345 200L344 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M646 199L647 200L646 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M342 200L343 201L342 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M343 200L344 201L343 200M647 200L648 201L647 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M648 200L649 201L648 200M341 201L342 202L341 201M649 201L650 202L649 201M340 202L341 203L340 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M650 202L651 203L650 202M339 203L340 204L339 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M651 203L652 204L651 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M338 204L339 205L338 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M652 204L653 205L652 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M653 204L654 205L653 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M337 205L338 206L337 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M654 205L655 206L654 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M336 206L337 207L336 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M655 206L656 207L655 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M335 207L336 208L335 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M656 207L657 208L656 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M334 208L335 209L334 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M657 208L658 209L657 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M333 209L334 210L333 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M658 209L659 210L658 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M659 210L660 211L659 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M330 211L331 212L330 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M660 211L661 212L660 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M329 212L330 213L329 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M661 212L662 213L661 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M328 213L329 214L328 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M662 213L663 214L662 213M663 214L664 215L663 214M327 215L328 216L327 215M664 215L665 216L664 215M326 216L327 217L326 216M665 216L666 217L665 216M325 217L326 218L325 217M666 217L667 218L666 217M324 218L325 219L324 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M667 218L668 219L667 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M323 219L324 220L323 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M668 219L669 220L668 219M322 220L323 221L322 220M669 220L670 221L669 220M321 221L322 222L321 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670 221L671 222L670 221M320 222L321 223L320 222M671 222L672 223L671 222M319 223L320 224L319 223M318 224L319 225L318 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M672 224L673 225L672 224M673 225L674 226L673 225M317 226L318 227L317 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M674 226L675 227L674 226M316 227L317 228L316 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M675 227L676 228L675 227M315 228L316 229L315 228M676 228L677 229L676 228M314 229L315 230L314 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M677 230L678 231L677 230M313 231L314 232L313 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M678 231L679 232L678 231M312 232L313 233L312 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M679 232L680 233L679 232M311 233L312 234L311 233M680 233L681 234L680 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M680 234L681 235L680 234M310 235L311 236L310 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M681 235L682 236L681 235M309 236L310 237L309 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M682 236L683 237L682 236M308 237L309 238L308 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 238L309 239L308 238M683 238L684 239L683 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M307 239L308 240L307 239M684 239L685 240L684 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M306 240L307 241L306 240M685 240L686 241L685 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M306 241L307 242L306 241M685 241L686 242L685 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M305 242L306 243L305 242M686 242L687 243L686 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M304 243L305 244L304 243M687 243L688 244L687 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M304 244L305 245L304 244M687 244L688 245L687 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M303 245L304 246L303 245M688 245L689 246L688 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M302 247L303 248L302 247M689 247L690 248L689 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M301 248L302 249L301 248M690 248L691 249L690 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M301 249L302 250L301 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M300 250L301 251L300 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M691 250L692 251L691 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M692 251L693 252L692 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M299 252L300 253L299 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M298 253L299 254L298 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M693 253L694 254L693 253M298 254L299 255L298 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 254L695 255L694 254M297 255L298 256L297 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M694 255L695 256L694 255M297 256L298 257L297 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M695 256L696 257L695 256M296 257L297 258L296 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M695 257L696 258L695 257M296 258L297 259L296 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M696 258L697 259L696 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M295 259L296 260L295 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M295 260L296 261L295 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M697 260L698 261L697 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M294 261L295 262L294 261M698 261L699 262L698 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M294 262L295 263L294 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M698 262L699 263L698 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M699 263L700 264L699 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M293 264L294 265L293 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M699 264L700 265L699 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M700 265L701 266L700 265M292 266L293 267L292 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M700 266L701 267L700 266M292 267L293 268L292 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701 267L702 268L701 267M291 268L292 269L291 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M291 269L292 270L291 269M702 269L703 270L702 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M290 271L291 272L290 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M703 271L704 272L703 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M290 272L291 273L290 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M289 273L290 274L289 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M704 273L705 274L704 273M289 274L290 275L289 274M705 275L706 276L705 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M288 276L289 277L288 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M288 277L289 278L288 277M706 277L707 278L706 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M287 279L288 280L287 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M707 279L708 280L707 279M287 280L288 281L287 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M708 281L709 282L708 281M286 282L287 283L286 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M708 282L709 283L708 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M286 283L287 284L286 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M709 283L710 284L709 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M286 284L287 285L286 284M709 284L710 285L709 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M710 285L711 286L710 285M285 286L286 287L285 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M710 286L711 287L710 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M285 287L286 288L285 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M711 287L712 288L711 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M285 288L286 289L285 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M711 288L712 289L711 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M284 290L285 291L284 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M712 290L713 291L712 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M284 291L285 292L284 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M582 291L578 296L582 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M583.333 291.667L583.667 292.333L583.333 291.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M283 292L284 293L283 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M582 292C561.062 311.286 535.008 331.726 507 339.116C497.001 341.754 470.685 344.407 468.232 330C466.464 319.61 475.979 309.137 481 301C461.467 302.596 440.563 312.883 424 322.8C392.406 341.717 360.916 376.376 357.529 415C356.121 431.046 360.281 448.994 361.83 465C365.135 499.149 371.441 529.728 392.478 558C425.184 601.955 488.379 627.966 542 610.971C558.127 605.86 571.201 596.365 584 585.561C604.599 568.173 622.103 540.885 634.244 517C645.029 495.782 646.022 476.242 647.039 453C647.367 445.511 650.22 435.298 648.227 428C646.172 420.478 637.384 413.728 634.204 406C630.492 396.981 628.442 387.669 627.286 378C626.785 373.814 628.132 368.217 626.397 364.329C624.619 360.347 618.3 357.845 615.001 355.192C608.726 350.148 603.719 343.721 599.345 337C590.263 323.046 590.115 305.459 582 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M713 292L714 293L713 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M283 293L284 294L283 293M583 293L584 294L583 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M713 293L714 294L713 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M583 294L584 295L583 294M714 294L715 295L714 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M282 295L283 296L282 295M714 295L715 296L714 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M282 296L283 297L282 296M576 296L577 297L576 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M281 297L282 298L281 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M575 297L576 298L575 297M584 297L585 298L584 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M715 297L716 298L715 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M281 298L282 299L281 298M574 298L575 299L574 298M584 298L585 299L584 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M715 298L716 299L715 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M573 299L574 300L573 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M584 299L585 300L584 299M716 299L717 300L716 299M280 300L281 301L280 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M478 300L479 301L478 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M479 300L480 301L479 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M480.667 300.333L481.333 300.667L480.667 300.333M572 300L573 301L572 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M716 300L717 301L716 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M280 301L281 302L280 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M474 301L475 302L474 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M475.667 301.333L476.333 301.667L475.667 301.333M571 301L572 302L571 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M585 301L586 302L585 301M470 302L471 303L470 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M471.667 302.333L472.333 302.667L471.667 302.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M480 302L481 303L480 302M569 302L570 303L569 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M585 302L586 303L585 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M717 302L718 303L717 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M279 303L280 304L279 303M467 303L468 304L467 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M468 303L469 304L468 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M479 303L480 304L479 303M568 303L569 304L568 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M585 303L586 304L585 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M717 303L718 304L717 303M279 304L280 305L279 304M463 304L464 305L463 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M464 304L465 305L464 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M465 304L466 305L465 304M478 304L479 305L478 304M567 304L568 305L567 304M718 304L719 305L718 304M278 305L279 306L278 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M460 305L461 306L460 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M461 305L462 306L461 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M462 305L463 306L462 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M478 305L479 306L478 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M566 305L567 306L566 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M586 305L587 306L586 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M718 305L719 306L718 305M278 306L279 307L278 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M457 306L458 307L457 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M458 306L459 307L458 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M459 306L460 307L459 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M477 306L478 307L477 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M564 306L565 307L564 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M586 306L587 307L586 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M278 307L279 308L278 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M455 307L456 308L455 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M456 307L457 308L456 307M476 307L477 308L476 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M563 307L564 308L563 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M586 307L587 308L586 307M719 307L720 308L719 307M277 308L278 309L277 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M452 308L453 309L452 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M453 308L454 309L453 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M476 308L477 309L476 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M562 308L563 309L562 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M719 308L720 309L719 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M277 309L278 310L277 309M450 309L451 310L450 309M475 309L476 310L475 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M560 309L561 310L560 309M587 309L588 310L587 309M277 310L278 311L277 310M447 310L448 311L447 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M448 310L449 311L448 310M474 310L475 311L474 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M559 310L560 311L559 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M587.333 310.667L587.667 311.333L587.333 310.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M720 310L721 311L720 310M445 311L446 312L445 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M446 311L447 312L446 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M474 311L475 312L474 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M558 311L559 312L558 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M720 311L721 312L720 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M276 312L277 313L276 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M443 312L444 313L443 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M473 312L474 313L473 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M556 312L557 313L556 312M588 312L589 313L588 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M721 312L722 313L721 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M276 313L277 314L276 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M440 313L441 314L440 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M441 313L442 314L441 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M473 313L474 314L473 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M555 313L556 314L555 313M588 313L589 314L588 313M721 313L722 314L721 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M438 314L439 315L438 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M439 314L440 315L439 314M472 314L473 315L472 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M553 314L554 315L553 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M554 314L555 315L554 314M588 314L589 315L588 314M275.333 315.667L275.667 316.333L275.333 315.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M436 315L437 316L436 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M437 315L438 316L437 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M552 315L553 316L552 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M589 315L590 316L589 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M722 315L723 316L722 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M434 316L435 317L434 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M435 316L436 317L435 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M471 316L472 317L471 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M551 316L552 317L551 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M589 316L590 317L589 316M722 316L723 317L722 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M275 317L276 318L275 317M432 317L433 318L432 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M433 317L434 318L433 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M549 317L550 318L549 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M431 318L432 319L431 318M470 318L471 319L470 318M548 318L549 319L548 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M590 318L591 319L590 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M723 318L724 319L723 318M274 319L275 320L274 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M429 319L430 320L429 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M470 319L471 320L470 319M546 319L547 320L546 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M590 319L591 320L590 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M723 319L724 320L723 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M274 320L275 321L274 320M427 320L428 321L427 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M469 320L470 321L469 320M545 320L546 321L545 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M274 321L275 322L274 321M425 321L426 322L425 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M426 321L427 322L426 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M469 321L470 322L469 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M543 321L544 322L543 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M591 321L592 322L591 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M724 321L725 322L724 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M423 322L424 323L423 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M424 322L425 323L424 322M542 322L543 323L542 322M591 322L592 323L591 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M724 322L725 323L724 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M273.333 323.667L273.667 324.333L273.333 323.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M422 323L423 324L422 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M468.333 323.667L468.667 324.333L468.333 323.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M540 323L541 324L540 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M592 323L593 324L592 323M420 324L421 325L420 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M421 324L422 325L421 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M538 324L539 325L538 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M539 324L540 325L539 324M592 324L593 325L592 324M725 324L726 325L725 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M273 325L274 326L273 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M419 325L420 326L419 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M468 325L469 326L468 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M537 325L538 326L537 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M593 325L594 326L593 325M725 325L726 326L725 325M273 326L274 327L273 326M417 326L418 327L417 326M468 326L469 327L468 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M535 326L536 327L535 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593 326L594 327L593 326M416 327L417 328L416 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M533 327L534 328L533 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M726 327L727 328L726 327M272.333 328.667L272.667 329.333L272.333 328.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M414 328L415 329L414 328M531 328L532 329L531 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M532 328L533 329L532 328M594 328L595 329L594 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M726 328L727 329L726 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M413 329L414 330L413 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M529 329L530 330L529 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M530 329L531 330L530 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M272 330L273 331L272 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M411 330L412 331L411 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M412 330L413 331L412 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M468 330L469 331L468 330M527 330L528 331L527 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M528 330L529 331L528 330M595 330L596 331L595 330M727 330L728 331L727 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M272 331L273 332L272 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M410 331L411 332L410 331M468 331L469 332L468 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M525 331L526 332L525 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M526 331L527 332L526 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M596 331L597 332L596 331M727 331L728 332L727 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M409 332L410 333L409 332M468 332L469 333L468 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M523 332L524 333L523 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M524 332L525 333L524 332M596 332L597 333L596 332M271.333 333.667L271.667 334.333L271.333 333.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M407 333L408 334L407 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M408 333L409 334L408 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M521 333L522 334L521 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M522 333L523 334L522 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M597 333L598 334L597 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M728 333L729 334L728 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M406 334L407 335L406 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M469 334L470 335L469 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M519 334L520 335L519 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M520 334L521 335L520 334M597 334L598 335L597 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M728 334L729 335L728 334M271 335L272 336L271 335M405 335L406 336L405 335M470 335L471 336L470 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M516 335L517 336L516 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M517 335L518 336L517 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M598 335L599 336L598 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M271 336L272 337L271 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M404 336L405 337L404 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M471 336L472 337L471 336M514 336L515 337L514 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M515 336L516 337L515 336M729 336L730 337L729 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M402 337L403 338L402 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M403 337L404 338L403 337M472 337L473 338L472 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M473 337L474 338L473 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M511 337L512 338L511 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M512 337L513 338L512 337M599 337L600 338L599 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M729 337L730 338L729 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M401 338L402 339L401 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M474 338L475 339L474 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M475 338L476 339L475 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M507 338L508 339L507 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M508 338L509 339L508 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M509 338L510 339L509 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M600 338L601 339L600 338M729 338L730 339L729 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M270.333 339.667L270.667 340.333L270.333 339.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M400 339L401 340L400 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M478 339L479 340L478 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M479 339L479 340L482 340L479 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M482 339L482 340L485 340L482 339M503 339L504 340L503 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M504 339L505 340L504 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M505 339L506 340L505 339M730.333 339.667L730.667 340.333L730.333 339.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M399 340L400 341L399 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M486 340L487 341L486 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M487.667 340.333L488.333 340.667L487.667 340.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M489.667 340.333L490.333 340.667L489.667 340.333M496.667 340.333L497.333 340.667L496.667 340.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M498.667 340.333L499.333 340.667L498.667 340.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M500.667 340.333L501.333 340.667L500.667 340.333M601 340L602 341L601 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M270.333 341.667L270.667 342.333L270.333 341.667M398 341L399 342L398 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M602 341L603 342L602 341M730 341L731 342L730 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M397 342L398 343L397 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M270 343L271 344L270 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M396 343L397 344L396 343M603 343L604 344L603 343M731 343L732 344L731 343M395 344L396 345L395 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M604 344L605 345L604 344M731 344L732 345L731 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M394 345L395 346L394 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M605 345L606 346L605 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M269.333 346.667L269.667 347.333L269.333 346.667M393 346L394 347L393 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M606 346L607 347L606 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M732.333 346.667L732.667 347.333L732.333 346.667M392 347L393 348L392 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M607 347L608 348L607 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M269.333 348.667L269.667 349.333L269.333 348.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M391 348L392 349L391 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M732 348L733 349L732 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M390 349L391 350L390 349M608 349L609 350L608 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M269.333 350.667L269.667 351.333L269.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M389 350L390 351L389 350M609 350L610 351L609 350M733 350L734 351L733 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M388 351L389 352L388 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M610 351L611 352L610 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M733 351L734 352L733 351M387 352L388 353L387 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M611 352L612 353L611 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M733 352L734 353L733 352M386 353L387 354L386 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M612 353L613 354L612 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M613 353L614 354L613 353M385 354L386 355L385 354M614 354L615 355L614 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M734 354L735 355L734 354M268 355L268 358L269 358L268 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M615 355L616 356L615 355M734 355L735 356L734 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M384 356L385 357L384 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M616 356L617 357L616 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M734 356L735 357L734 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M383 357L384 358L383 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M617 357L618 358L617 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M618 357L619 358L618 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M268 358L268 361L269 361L268 358M382 358L383 359L382 358M619 358L620 359L619 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M735 358L736 359L735 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M381 359L382 360L381 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M620 359L621 360L620 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M735 359L736 360L735 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M381 360L382 361L381 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M622 360L623 361L622 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M735 360L736 361L735 360M268.333 361.667L268.667 362.333L268.333 361.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M380 361L381 362L380 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M624 361L625 362L624 361M379 362L380 363L379 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M625 362L626 363L625 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M626 362L627 363L626 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M736 362L737 363L736 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M736 363L737 364L736 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M378 364L379 365L378 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M736 364L737 365L736 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M377 365L378 366L377 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M376 366L377 367L376 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M737 366L738 367L737 366M267 367L267 374L268 374L267 367M376 367L377 368L376 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M737 367L738 368L737 367M375 368L376 369L375 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M737 368L738 369L737 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M374 370L375 371L374 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M627 370L627 374L628 374L627 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M738 370L739 371L738 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M373 371L374 372L373 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M738 371L739 372L738 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M373 372L374 373L373 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M738 372L739 373L738 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M372 373L373 374L372 373M267 374L267 381L268 381L267 374M627 374L627 377L628 377L627 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M371 375L372 376L371 375M739 375L740 376L739 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 376L371 377L370 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M739 376L740 377L739 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M370 377L371 378L370 377M627 377L627 380L628 380L627 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M739 377L740 378L739 377M369 378L370 379L369 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M369 379L370 380L369 379M740.333 379.667L740.667 380.333L740.333 379.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M368 380L369 381L368 380M267 381L267 396L268 396L267 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M368 381L369 382L368 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M740 381L741 382L740 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M367 382L368 383L367 382M740 382L741 383L740 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M367 383L368 384L367 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M628 383L629 384L628 383M366 384L367 385L366 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M628 384L629 385L628 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M741.333 384.667L741.667 385.333L741.333 384.667M366 385L367 386L366 385M628.333 385.667L628.667 386.333L628.333 385.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M741 386L742 387L741 386M365 387L366 388L365 387M658 387L659 388L658 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M741 387L742 388L741 387M657.333 388.667L657.667 389.333L657.333 388.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M658 388C656.78 416.414 654.587 449.345 648 477C678.397 461.231 678.329 411.398 658 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M364 389L365 390L364 389M629 389L630 390L629 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M659 389L660 390L659 389M364 390L365 391L364 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M629 390L630 391L629 390M657.333 390.667L657.667 391.333L657.333 390.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M660 390L661 391L660 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M742.333 390.667L742.667 391.333L742.333 390.667M629 391L630 392L629 391M660 391L661 392L660 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M363 392L364 393L363 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M657.333 392.667L657.667 393.333L657.333 392.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M661 392L662 393L661 392M742 392L743 393L742 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M363 393L364 394L363 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M630 393L631 394L630 393M742 393L743 394L742 393M362 394L363 395L362 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M630 394L631 395L630 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M662 394L663 395L662 394M362 395L363 396L362 395M630 395L631 396L630 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M663 395L664 396L663 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M743.333 395.667L743.667 396.333L743.333 395.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M267 396L267 404L268 404L267 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M663 396L664 397L663 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M361 397L362 398L361 397M631 397L632 398L631 397M656.333 397.667L656.667 398.333L656.333 397.667M664 397L665 398L664 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M743.333 397.667L743.667 398.333L743.333 397.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M361 398L362 399L361 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M631 398L632 399L631 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M664 398L665 399L664 398M631 399L632 400L631 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M656.333 399.667L656.667 400.333L656.333 399.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M665 399L666 400L665 399M743 399L744 400L743 399M360 400L361 401L360 400M632 400L633 401L632 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 400L666 401L665 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M360 401L361 402L360 401M632 401L633 402L632 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M656 401L656 404L657 404L656 401M360 402L361 403L360 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M666 402L667 403L666 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M744.333 402.667L744.667 403.333L744.333 402.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M633 403L634 404L633 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M267 404L267 411L268 411L267 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M359 404L360 405L359 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 404L634 405L633 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M667 404L668 405L667 404M744.333 404.667L744.667 405.333L744.333 404.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M359 405L360 406L359 405M667 405L668 406L667 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M634 406L635 407L634 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M655.333 406.667L655.667 407.333L655.333 406.667M744.333 406.667L744.667 407.333L744.333 406.667M358 407L359 408L358 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M668 407L669 408L668 407M358 408L359 409L358 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M635 408L636 409L635 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M655.333 408.667L655.667 409.333L655.333 408.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M668 408L669 409L668 408M358 409L359 410L358 409M635 409L636 410L635 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M669 409L670 410L669 409M636 410L637 411L636 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M655 410L655 413L656 413L655 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M669 410L670 411L669 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M636 411L637 412L636 411M669 411L670 412L669 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M357.333 412.667L357.667 413.333L357.333 412.667M637 412L638 413L637 412M670 413L671 414L670 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M745.333 413.667L745.667 414.333L745.333 413.667M357 414L358 415L357 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M638 414L639 415L638 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670 414L671 415L670 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M639 415L640 416L639 415M654.333 415.667L654.667 416.333L654.333 415.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M745.333 415.667L745.667 416.333L745.333 415.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M268 416L268 419L269 419L268 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 416L640 417L639 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M640 417L641 418L640 417M654.333 417.667L654.667 418.333L654.333 417.667M671.333 417.667L671.667 418.333L671.333 417.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M745.333 417.667L745.667 418.333L745.333 417.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M357 418L357 422L358 422L357 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M641 418L642 419L641 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M268 419L268 422L269 422L268 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M641 419L642 420L641 419M654 419L654 422L655 422L654 419M671 419L672 420L671 419M642 420L643 421L642 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M643 421L644 422L643 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M268 422L268 426L269 426L268 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M357 422L357 425L358 425L357 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M644 422L645 423L644 422M672.333 422.667L672.667 423.333L672.333 422.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M746 422L746 425L747 425L746 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M645 423L646 424L645 423M646 424L647 425L646 424M653.333 424.667L653.667 425.333L653.333 424.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M672 424L672 427L673 427L672 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M357.333 425.667L357.667 426.333L357.333 425.667M647 425L648 426L647 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M746.333 425.667L746.667 426.333L746.333 425.667M648 426L649 427L648 426M653.333 426.667L653.667 427.333L653.333 426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 427L672 434L673 434L672 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M746.333 427.667L746.667 428.333L746.333 427.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M653 428L653 431L654 431L653 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M269.333 430.667L269.667 431.333L269.333 430.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M358 430L358 433L359 433L358 430M648 430L648 436L649 436L648 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M269.333 432.667L269.667 433.333L269.333 432.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M747 432L747 436L748 436L747 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M358 433L358 436L359 436L358 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M652.333 433.667L652.667 434.333L652.333 433.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M269.333 434.667L269.667 435.333L269.333 434.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M672.333 434.667L672.667 435.333L672.333 434.667M652.333 435.667L652.667 436.333L652.333 435.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M358.333 436.667L358.667 437.333L358.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M648 436L648 440L649 440L648 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M672.333 436.667L672.667 437.333L672.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M747 436L747 439L748 439L747 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 437L652 440L653 440L652 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M270.333 438.667L270.667 439.333L270.333 438.667M747 439L747 442L748 442L747 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M270.333 440.667L270.667 441.333L270.333 440.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M648 440L648 443L649 443L648 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M671 440L672 441L671 440M359 441L359 444L360 444L359 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M671 441L672 442L671 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M270 442L270 445L271 445L270 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M651.333 442.667L651.667 443.333L651.333 442.667M671 442L672 443L671 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M359.333 444.667L359.667 445.333L359.333 444.667M651.333 444.667L651.667 445.333L651.333 444.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670.333 444.667L670.667 445.333L670.333 444.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M359.333 446.667L359.667 447.333L359.333 446.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M651 446L651 449L652 449L651 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M670 446L671 447L670 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M748 446L748 451L749 451L748 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M271 448L271 451L272 451L271 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M647 448L647 454L648 454L647 448M669 448L670 449L669 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M669 449L670 450L669 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M271 451L271 454L272 454L271 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M360 451L360 455L361 455L360 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M668 451L669 452L668 451M748 451L748 455L749 455L748 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M650 452L651 453L650 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M650.333 453.667L650.667 454.333L650.333 453.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M667 453L668 454L667 453M271 454L271 460L272 460L271 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M647 454L647 458L648 458L647 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M667 454L668 455L667 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M360.333 455.667L360.667 456.333L360.333 455.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M650 455L650 458L651 458L650 455M666 455L667 456L666 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M748 455L748 460L749 460L748 455M666 456L667 457L666 456M360.333 457.667L360.667 458.333L360.333 457.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 457L666 458L665 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M647 458L647 462L648 462L647 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M664 459L665 460L664 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M649 461L650 462L649 461M663 461L664 462L663 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M361 462L361 466L362 466L361 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M649.333 462.667L649.667 463.333L649.333 462.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M662 462L663 463L662 462M649 464L649 467L650 467L649 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M661 464L662 465L661 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M660 465L661 466L660 465M361.333 466.667L361.667 467.333L361.333 466.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M659 466L660 467L659 466M646 467L646 473L647 473L646 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M361.333 468.667L361.667 469.333L361.333 468.667M658 468L659 469L658 468M657 469L658 470L657 469M648 470L649 471L648 470M656 470L657 471L656 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M749 470L749 489L750 489L749 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M648.333 471.667L648.667 472.333L648.333 471.667M655 471L656 472L655 471M654 472L655 473L654 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M362 473L362 476L363 476L362 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M646 473L646 478L647 478L646 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M648 473L648 476L649 476L648 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M653 473L654 474L653 473M652 474L653 475L652 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M651 475L652 476L651 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M362.333 476.667L362.667 477.333L362.333 476.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 476L650 477L649 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M650 476L651 477L650 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M648 477L649 478L648 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M362.333 478.667L362.667 479.333L362.333 478.667M646 478L646 482L647 482L646 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M271 479L271 485L272 485L271 479M363 483L363 487L364 487L363 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M271 485L271 488L272 488L271 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M645 486L646 487L645 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M363.333 487.667L363.667 488.333L363.333 487.667M645 487L646 488L645 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M271 488L271 491L272 491L271 488M645 488L646 489L645 488M363.333 489.667L363.667 490.333L363.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M644.333 490.667L644.667 491.333L644.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M644 492L645 493L644 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M364.333 493.667L364.667 494.333L364.333 493.667M270 494L270 497L271 497L270 494M643 494L644 495L643 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M364 495L365 496L364 495M643 495L644 496L643 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M364 496L365 497L364 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M270.333 497.667L270.667 498.333L270.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M642 497L643 498L642 497M365.333 498.667L365.667 499.333L365.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M642 498L643 499L642 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M748 498L748 502L749 502L748 498M270 499L271 500L270 499M365 500L366 501L365 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M641 500L642 501L641 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M641 501L642 502L641 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M269 502L269 505L270 505L269 502M366.333 502.667L366.667 503.333L366.333 502.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M748 502L748 506L749 506L748 502M640 503L641 504L640 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M366 504L367 505L366 504M640 504L641 505L640 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M269 505L270 506L269 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 505L640 506L639 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M269 506L270 507L269 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M367 506L368 507L367 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M639 506L640 507L639 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M748 506L748 511L749 511L748 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M367 507L368 508L367 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M367 508L368 509L367 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M638 508L639 509L638 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M268.333 509.667L268.667 510.333L268.333 509.667M368 510L369 511L368 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M637 510L638 511L637 510M268 511L269 512L268 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M368 511L369 512L368 511M268 512L269 513L268 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M636 512L637 513L636 512M369 513L370 514L369 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M636 513L637 514L636 513M369 514L370 515L369 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M635 514L636 515L635 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M747 514L747 517L748 517L747 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M267.333 515.667L267.667 516.333L267.333 515.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M635 515L636 516L635 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M370 516L371 517L370 516M634 516L635 517L634 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M267 517L268 518L267 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 517L371 518L370 517M634 517L635 518L634 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M747.333 517.667L747.667 518.333L747.333 517.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M267 518L268 519L267 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M371 518L372 519L371 518M633 518L634 519L633 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M371 519L372 520L371 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M747 519L747 522L748 522L747 519M266 520L267 521L266 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M632 520L633 521L632 520M266 521L267 522L266 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M372 521L373 522L372 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M266 522L267 523L266 522M372 522L373 523L372 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M631 522L632 523L631 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M630 523L631 524L630 523M265.333 524.667L265.667 525.333L265.333 524.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M373 524L374 525L373 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M630 524L631 525L630 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M629 525L630 526L629 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M746.333 525.667L746.667 526.333L746.333 525.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M265 526L266 527L265 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M374 526L375 527L374 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M629 526L630 527L629 526M374 527L375 528L374 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M628 527L629 528L628 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M746 527L747 528L746 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M375 528L376 529L375 528M746 528L746 531L747 531L746 528M264 529L265 530L264 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M375 529L376 530L375 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M627 529L628 530L627 529M264 530L265 531L264 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M376 530L377 531L376 530M626 530L627 531L626 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M376 531L377 532L376 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M626 531L627 532L626 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M263 532L264 533L263 532M625 532L626 533L625 532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M263 533L264 534L263 533M377 533L378 534L377 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M745 533L746 534L745 533M263 534L264 535L263 534M624 534L625 535L624 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M745.333 534.667L745.667 535.333L745.333 534.667M378 535L379 536L378 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 535L624 536L623 535M262 536L263 537L262 536M745.333 536.667L745.667 537.333L745.333 536.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M262 537L263 538L262 537M379 537L380 538L379 537M622 537L623 538L622 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M380 538L381 539L380 538M621 538L622 539L621 538M261 539L262 540L261 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M380 539L381 540L380 539M261 540L262 541L261 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M381 540L382 541L381 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M620 540L621 541L620 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M744 540L745 541L744 540M261 541L262 542L261 541M381 541L382 542L381 541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M619 541L620 542L619 541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M744.333 541.667L744.667 542.333L744.333 541.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M260 542L261 543L260 542M382 542L383 543L382 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M260 543L261 544L260 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M382 543L383 544L382 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M618 543L619 544L618 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M744 543L745 544L744 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M260 544L261 545L260 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M383 544L384 545L383 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M617 544L618 545L617 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M259 546L260 547L259 546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M384 546L385 547L384 546M616 546L617 547L616 546M743 546L744 547L743 546M259 547L260 548L259 547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M385 547L386 548L385 547M615 547L616 548L615 547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M743 547L744 548L743 547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M258 548L259 549L258 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M385 548L386 549L385 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M614 548L615 549L614 548M743.333 548.667L743.667 549.333L743.333 548.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M258 549L259 550L258 549M386 549L387 550L386 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M614 549L615 550L614 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M387 550L388 551L387 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M613 550L614 551L613 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M257 551L258 552L257 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M387 551L388 552L387 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M612 551L613 552L612 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M257 552L258 553L257 552M388 552L389 553L388 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M742 552L743 553L742 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M389 553L390 554L389 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M611 553L612 554L611 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M742 553L743 554L742 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M256 554L257 555L256 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M389 554L390 555L389 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M610 554L611 555L610 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M742 554L743 555L742 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M256 555L257 556L256 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M390 555L391 556L390 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M609 555L610 556L609 555M255 556L256 557L255 556M391 556L392 557L391 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M255 557L256 558L255 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M608 557L609 558L608 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M741 557L742 558L741 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M392 558L393 559L392 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M607 558L608 559L607 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M741.333 558.667L741.667 559.333L741.333 558.667M254 559L255 560L254 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M393 559L394 560L393 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M606 559L607 560L606 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M254 560L255 561L254 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M394 560L395 561L394 560M605 560L606 561L605 560M253 561L254 562L253 561M395 561L396 562L395 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M605 561L606 562L605 561M740 561L741 562L740 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M253 562L254 563L253 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M395 562L396 563L395 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M604 562L605 563L604 562M740 562L741 563L740 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M396 563L397 564L396 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M603 563L604 564L603 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M740 563L741 564L740 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M252 564L253 565L252 564M397 564L398 565L397 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M602 564L603 565L602 564M398 565L399 566L398 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M739 565L740 566L739 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M251 566L252 567L251 566M399 566L400 567L399 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M601 566L602 567L601 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M739 566L740 567L739 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M251 567L252 568L251 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M400 567L401 568L400 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M600 567L601 568L600 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M739 567L740 568L739 567M250 568L251 569L250 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M599 568L600 569L599 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M250 569L251 570L250 569M401 569L402 570L401 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M598 569L599 570L598 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M738 569L739 570L738 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M249 570L250 571L249 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M402 570L403 571L402 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M738 570L739 571L738 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M249 571L250 572L249 571M403 571L404 572L403 571M597 571L598 572L597 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M738 571L739 572L738 571M248 572L249 573L248 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M404 572L405 573L404 572M596 572L597 573L596 572M248 573L249 574L248 573M405 573L406 574L405 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M595 573L596 574L595 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M737 573L738 574L737 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M247 574L248 575L247 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M406 574L407 575L406 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M594 574L595 575L594 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M737 574L738 575L737 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M247 575L248 576L247 575M407 575L408 576L407 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593 575L594 576L593 575M737 575L738 576L737 575M246 576L247 577L246 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M408 576L409 577L408 576M246 577L247 578L246 577M409 577L410 578L409 577M592 577L593 578L592 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M736 577L737 578L736 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M245 578L246 579L245 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M410 578L411 579L410 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M591 578L592 579L591 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M736 578L737 579L736 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M245 579L246 580L245 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M412 579L413 580L412 579M590 579L591 580L590 579M244 580L245 581L244 580M413 580L414 581L413 580M589 580L590 581L589 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M735 580L736 581L735 580M244 581L245 582L244 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M414 581L415 582L414 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M588 581L589 582L588 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M735 581L736 582L735 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M243 582L244 583L243 582M415 582L416 583L415 582M587 582L588 583L587 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M416 583L417 584L416 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M586 583L587 584L586 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M734 583L735 584L734 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M242 584L243 585L242 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M418 584L419 585L418 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M585 584L586 585L585 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M734 584L735 585L734 584M241 585L242 586L241 585M419 585L420 586L419 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M584 585L585 586L584 585M241 586L242 587L241 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M420 586L421 587L420 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M582 586L583 587L582 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M733 586L734 587L733 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M240 587L241 588L240 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M421 587L422 588L421 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M422 587L423 588L422 587M581 587L582 588L581 587M733 587L734 588L733 587M423 588L424 589L423 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M580 588L581 589L580 588M239 589L240 590L239 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M424 589L425 590L424 589M579 589L580 590L579 589M732 589L733 590L732 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M238 590L239 591L238 590M426 590L427 591L426 590M577 590L578 591L577 590M732 590L733 591L732 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M238 591L239 592L238 591M427 591L428 592L427 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M576 591L577 592L576 591M237 592L238 593L237 592M429 592L430 593L429 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M575 592L576 593L575 592M731 592L732 593L731 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M430 593L431 594L430 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M431 593L432 594L431 593M573 593L574 594L573 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M574 593L575 594L574 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M731 593L732 594L731 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M236 594L237 595L236 594M432 594L433 595L432 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M572 594L573 595L572 594M235 595L236 596L235 595M434 595L435 596L434 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M571 595L572 596L571 595M730 595L731 596L730 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M435 596L436 597L435 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M436 596L437 597L436 596M569 596L568 598L569 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M570 596L571 597L570 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M730 596L731 597L730 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M234.333 597.667L234.667 598.333L234.333 597.667M437 597L438 598L437 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M438 597L439 598L438 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M569 597L570 598L569 597M729 597L730 598L729 597M439.667 598.333L440.333 598.667L439.667 598.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M441 598L442 599L441 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M567 598L568 599L567 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M568 598L569 599L568 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M729 598L730 599L729 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M235 599L236 600L235 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M442 599L444 601L442 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M443 599L444 600L443 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M566 599L567 600L566 599M236 600L237 601L236 600M444 600L445 601L444 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M445 600L446 601L445 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M565 600L566 601L565 600M728 600L729 601L728 600M237 601L238 602L237 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M445 601L446 602L445 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M446 601L447 602L446 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M447 601L448 602L447 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M564 601L565 602L564 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M728 601L729 602L728 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M238 602L239 603L238 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M447 602L448 603L447 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M448 602L449 603L448 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M449 602L450 603L449 602M561 602L562 603L561 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M562 602L563 603L562 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M563 602L564 603L563 602M727 602L728 603L727 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M239 603L240 604L239 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M442 603L443 604L442 603M449 603L450 604L449 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M450 603L451 604L450 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M451 603L452 604L451 603M559 603L557 604L557 605L559 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M560 603L561 604L560 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M561 603L562 604L561 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M727 603L728 604L727 603M240 604L241 605L240 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M442 604L443 605L442 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M443 604L444 605L443 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M444 604L445 605L444 604M451 604L452 605L451 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M452 604L453 605L452 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M453 604L454 605L453 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M559 604L560 605L559 604M726 604L727 605L726 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M241 605L242 606L241 605M442 605L442 622L443 622L442 605M445 605L446 606L445 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M446 605L447 606L446 605M453 605L454 606L453 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M454 605L455 606L454 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M455 605L456 606L455 605M555 605L556 606L555 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M556 605L557 606L556 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M557 605L558 606L557 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M564 605L566 607L564 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M565 605L566 606L565 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M726 605L727 606L726 605M242 606L243 607L242 606M447 606L448 607L447 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M448 606L449 607L448 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M456 606L457 607L456 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M457 606L458 607L457 606M553 606L554 607L553 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M554 606L555 607L554 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M555 606L556 607L555 606M562 606L563 607L562 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M563 606L564 607L563 606M243 607L244 608L243 607M449 607L450 608L449 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M450 607L451 608L450 607M458 607L459 608L458 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M459 607L460 608L459 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M460 607L461 608L460 607M551 607L552 608L551 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M552 607L553 608L552 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M553 607L554 608L553 607M560 607L561 608L560 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M561 607L562 608L561 607M565.333 607.667L565.667 608.333L565.333 607.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M725 607L726 608L725 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M244 608L245 609L244 608M451 608L452 609L451 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M452 608L453 609L452 608M461 608L462 609L461 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M462.667 608.333L463.333 608.667L462.667 608.333M548.667 608.333L549.333 608.667L548.667 608.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M550 608L551 609L550 608M558 608L559 609L558 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M559 608L560 609L559 608M245 609L246 610L245 609M453 609L454 610L453 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M454 609L455 610L454 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M455 609L456 610L455 609M463 609L464 610L463 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M464 609L465 610L464 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M465.667 609.333L466.333 609.667L465.667 609.333M546 609L547 610L546 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M547 609L548 610L547 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M548 609L549 610L548 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M556 609L557 610L556 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M557 609L558 610L557 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M566 609L567 610L566 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M724 609L725 610L724 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M247 610L248 611L247 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M455.667 610.333L456.333 610.667L455.667 610.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M457 610L458 611L457 610M466 610L467 611L466 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M467 610L468 611L467 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M468.667 610.333L469.333 610.667L468.667 610.333M543 610L544 611L543 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M544 610L545 611L544 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M545 610L546 611L545 610M553 610L554 611L553 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M554 610L555 611L554 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M555 610L556 611L555 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M566 610L567 611L566 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M724 610L725 611L724 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M248 611L249 612L248 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M458 611L459 612L458 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M459 611L460 612L459 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M460 611L461 612L460 611M469 611L470 612L469 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M470 611L471 612L470 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M471.667 611.333L472.333 611.667L471.667 611.333M540 611L541 612L540 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M541 611L542 612L541 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M542 611L543 612L542 611M551 611L552 612L551 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M552 611L553 612L552 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M553 611L554 612L553 611M566 611L567 612L566 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M723 611L724 612L723 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M249 612L250 613L249 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M460.667 612.333L461.333 612.667L460.667 612.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M462 612L463 613L462 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M463 612L464 613L463 612M473 612L474 613L473 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M474 612L475 613L474 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M475.667 612.333L476.333 612.667L475.667 612.333M536.667 612.333L537.333 612.667L536.667 612.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M538 612L539 613L538 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M539 612L540 613L539 612M548 612L549 613L548 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M549 612L550 613L549 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M550 612L551 613L550 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M567 612L568 613L567 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M723 612L724 613L723 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M250 613L251 614L250 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M463.667 613.333L464.333 613.667L463.667 613.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M465 613L466 614L465 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M466 613L467 614L466 613M476.667 613.333L477.333 613.667L476.667 613.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M478 613L479 614L478 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M479 613L479 614L482 614L479 613M532.667 613.333L533.333 613.667L532.667 613.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M534 613L535 614L534 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M535.667 613.333L536.333 613.667L535.667 613.333M546 613L547 614L546 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M547 613L548 614L547 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M548 613L549 614L548 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M567 613L568 614L567 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M722 613L723 614L722 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M251 614L252 615L251 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M466.667 614.333L467.333 614.667L466.667 614.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M468 614L469 615L468 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M469 614L470 615L469 614M481 614L482 615L481 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M482.667 614.333L483.333 614.667L482.667 614.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M484 614L484 615L487 615L484 614M527 614L527 615L530 615L527 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M530 614L531 615L530 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M531 614L532 615L531 614M543 614L544 615L543 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M544 614L545 615L544 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M545 614L546 615L545 614M567 614L568 615L567 614M722 614L723 615L722 614M252 615L253 616L252 615M469.667 615.333L470.333 615.667L469.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M471 615L472 616L471 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M472 615L473 616L472 615M486.667 615.333L487.333 615.667L486.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M488.667 615.333L489.333 615.667L488.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M490 615L490 616L494 616L490 615M519 615L519 616L524 616L519 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M524.667 615.333L525.333 615.667L524.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M526 615L527 616L526 615M539.667 615.333L540.333 615.667L539.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M541 615L542 616L541 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M542 615L543 616L542 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M568 615L569 616L568 615M721 615L722 616L721 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M253 616L254 617L253 616M473.667 616.333L474.333 616.667L473.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M475 616L476 617L475 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M476 616L477 617L476 616M493 616L493 617L496 617L493 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M496 616L496 617L499 617L496 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M499 616L499 617L515 617L499 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M515 616L515 617L518 617L515 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M518 616L518 617L521 617L518 616M536 616L537 617L536 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M537 616L538 617L537 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M538.667 616.333L539.333 616.667L538.667 616.333M568 616L569 617L568 616M721 616L722 617L721 616M254 617L255 618L254 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M255 617L256 618L255 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M477.667 617.333L478.333 617.667L477.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M479 617L480 618L479 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M480.667 617.333L481.333 617.667L480.667 617.333M532 617L533 618L532 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M533 617L534 618L533 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M534.667 617.333L535.333 617.667L534.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M569 617L570 618L569 617M720 617L721 618L720 617M256 618L257 619L256 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M481 618L481 619L484 619L481 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M484 618L485 619L484 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M485 618L485 619L488 619L485 618M526.667 618.333L527.333 618.667L526.667 618.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M528 618L529 619L528 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M529 618L529 619L532 619L529 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M569 618L570 619L569 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M720 618L721 619L720 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M257 619L258 620L257 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M486 619L486 620L490 620L486 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M490.667 619.333L491.333 619.667L490.667 619.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M492 619L492 620L495 620L492 619M518 619L518 620L521 620L518 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M521.667 619.333L522.333 619.667L521.667 619.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M523 619L523 620L527 620L523 619M569 619L570 620L569 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M719 619L720 620L719 619M258 620L259 621L258 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M494 620L494 621L502 621L494 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M502 620L502 621L512 621L502 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M512 620L512 621L520 621L512 620M259 621L260 622L259 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M570 621L571 622L570 621M718 621L719 622L718 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M260 622L261 623L260 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M261 622L262 623L261 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M442 622L443 623L442 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M570 622L571 623L570 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M262 623L263 624L262 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M442 623L442 631L443 631L442 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M571 623L572 624L571 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M717 623L718 624L717 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M263 624L264 625L263 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M571.333 624.667L571.667 625.333L571.333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M716 624L717 625L716 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M264 625L265 626L264 625M716 625L717 626L716 625M265 626L266 627L265 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M266 626L267 627L266 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M715 626L716 627L715 626M267 627L268 628L267 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M572 627L573 628L572 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M268 628L269 629L268 628M572 628L573 629L572 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M714 628L715 629L714 628M269 629L270 630L269 629M572.333 629.667L572.667 630.333L572.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M713 629L714 630L713 629M271 630L272 631L271 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M713 630L714 631L713 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M272 631L273 632L272 631M712 631L713 632L712 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M273 632L274 633L273 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M573 632L574 633L573 632M711 632L712 633L711 632M275 633L276 634L275 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M573 633L574 634L573 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M711 633L712 634L711 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M276 634L277 635L276 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M573 634L574 635L573 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M710 634L711 635L710 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M277 635L278 636L277 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M278 635L279 636L278 635M441 635L442 636L441 635M709 635L710 636L709 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M279 636L280 637L279 636M441.333 636.667L441.667 637.333L441.333 636.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M574 636L575 637L574 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M709 636L710 637L709 636M280 637L281 638L280 637M574.333 637.667L574.667 638.333L574.333 637.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M708 637L709 638L708 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M282 638L283 639L282 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M441 638L441 641L442 641L441 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M707 638L708 639L707 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M283 639L284 640L283 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M285 640L286 641L285 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M575 640L576 641L575 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M706 640L707 641L706 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M286 641L287 642L286 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M575 641L576 642L575 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M705 641L706 642L705 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M287 642L288 643L287 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M288 642L289 643L288 642M440 642L441 643L440 642M704 642L705 643L704 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M289 643L290 644L289 643M440.333 643.667L440.667 644.333L440.333 643.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M576 643L577 644L576 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M704 643L705 644L704 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M291 644L292 645L291 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M576 644L577 645L576 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M703 644L704 645L703 644M292 645L293 646L292 645M440 645L441 646L440 645M576 645L577 646L576 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M702 645L703 646L702 645M294 646L295 647L294 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M701 646L702 647L701 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M295 647L296 648L295 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M296 647L297 648L296 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M577 647L578 648L577 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M700 647L701 648L700 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M297 648L298 649L297 648M439 648L440 649L439 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M577 648L578 649L577 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M299 649L300 650L299 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M439.333 649.667L439.667 650.333L439.333 649.667M699 649L700 650L699 649M300 650L301 651L300 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M301 650L302 651L301 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M578 650L579 651L578 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M698 650L699 651L698 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M302 651L303 652L302 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M578 651L579 652L578 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M697 651L698 652L697 651M304 652L305 653L304 652M438 652L439 653L438 652M696 652L697 653L696 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M305 653L306 654L305 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M306 653L307 654L306 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M438 653L439 654L438 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M579 653L580 654L579 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M695 653L696 654L695 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M307 654L308 655L307 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 654L309 655L308 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M579 654L580 655L579 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M694 654L695 655L694 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M309 655L310 656L309 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M437 655L438 656L437 655M580 655L581 656L580 655M693 655L694 656L693 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M311 656L312 657L311 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M437 656L438 657L437 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M580 656L581 657L580 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M692 656L693 657L692 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M313 657L314 658L313 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M691 657L692 658L691 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M315 658L316 659L315 658M436 658L437 659L436 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M581 658L582 659L581 658M690 658L691 659L690 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M317 659L318 660L317 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M436 659L437 660L436 659M581 659L582 660L581 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M689 659L690 660L689 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M319 660L320 661L319 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M435 660L436 661L435 660M688 660L689 661L688 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M321 661L322 662L321 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M435 661L436 662L435 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M582 661L583 662L582 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M687 661L688 662L687 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M323 662L324 663L323 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M582 662L583 663L582 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M686 662L687 663L686 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M325 663L326 664L325 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M326 663L327 664L326 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M434 663L435 664L434 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M583 663L584 664L583 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M685 663L686 664L685 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M327 664L328 665L327 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M328 664L329 665L328 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M583 664L584 665L583 664M684 664L685 665L684 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M330 665L331 666L330 665M433 665L434 666L433 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M683 665L684 666L683 665M332 666L333 667L332 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M333 666L334 667L333 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M584 666L585 667L584 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M682 666L683 667L682 666M334 667L335 668L334 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M335 667L336 668L335 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M432 667L433 668L432 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M680 667L681 668L680 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M337 668L338 669L337 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M338 668L339 669L338 668M431 668L432 669L431 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M585 668L586 669L585 668M679 668L680 669L679 668M340 669L341 670L340 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M341 669L342 670L341 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M431 669L432 670L431 669M585 669L586 670L585 669M678 669L679 670L678 669M342 670L343 671L342 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M343 670L344 671L343 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M344 670L345 671L344 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M430 670L431 671L430 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M586 670L587 671L586 670M676 670L677 671L676 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M677 670L678 671L677 670M345 671L346 672L345 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M346 671L347 672L346 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M347 671L348 672L347 671M429 671L430 672L429 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M586 671L587 672L586 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M675 671L676 672L675 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M348.667 672.333L349.333 672.667L348.667 672.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M350 672L351 673L350 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M429 672L430 673L429 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M587 672L588 673L587 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M674 672L675 673L674 672M352 673L353 674L352 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M353 673L354 674L353 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M424 673L425 674L424 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M425 673L426 674L425 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M426.667 673.333L427.333 673.667L426.667 673.333M587 673L588 674L587 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M672 673L673 674L672 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M673 673L674 674L673 673M355.667 674.333L356.333 674.667L355.667 674.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M357 674L358 675L357 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M420 674L421 675L420 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M421 674L422 675L421 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M422.667 674.333L423.333 674.667L422.667 674.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M671 674L672 675L671 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M359.667 675.333L360.333 675.667L359.667 675.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M361 675L362 676L361 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M416 675L417 676L416 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M417 675L418 676L417 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M418.667 675.333L419.333 675.667L418.667 675.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M588 675L589 676L588 675M669 675L670 676L669 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670 675L671 676L670 675M364 676L365 677L364 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M365.667 676.333L366.333 676.667L365.667 676.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M411.667 676.333L412.333 676.667L411.667 676.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M413 676L413 677L416 677L413 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M588 676L589 677L588 676M668 676L669 677L668 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M369.667 677.333L370.333 677.667L369.667 677.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M371 677L372 678L371 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M372 677L373 678L372 677M406 677L407 678L406 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M407 677L408 678L407 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M408 677L408 678L411 678L408 677M588 677L589 678L588 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M666 677L667 678L666 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M375 678L375 679L378 679L375 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M378.667 678.333L379.333 678.667L378.667 678.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M380 678L380 679L383 679L380 678M401 678L402 679L401 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M402 678L403 679L402 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M403.667 678.333L404.333 678.667L403.667 678.333M665 678L666 679L665 678M388 679L388 680L398 680L388 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M589 679L590 680L589 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M663 679L664 680L663 679M589 680L590 681L589 680M661 680L662 681L661 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M589 681L590 682L589 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M659 681L660 682L659 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M660 681L661 682L660 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M657 682L658 683L657 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M658 682L659 683L658 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M590 683L591 684L590 683M655 683L656 684L655 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M656 683L657 684L656 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M653 684L654 685L653 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M591 685L592 686L591 685M650 685L651 686L650 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M651 685L652 686L651 685M591 686L592 687L591 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M648 686L649 687L648 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 686L650 687L649 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M592 687L593 688L592 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M647 687L648 688L647 687M592 688L593 689L592 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M645 688L646 689L645 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M646 688L647 689L646 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M593 689L594 690L593 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M644 689L645 690L644 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593 690L594 691L593 690M643 690L644 691L643 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M594 691L595 692L594 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M641 691L642 692L641 691M595 692L596 693L595 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M640 692L641 693L640 692M595 693L596 694L595 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M638 693L639 694L638 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M596 694L597 695L596 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M636 694L637 695L636 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M637 694L638 695L637 694M597 695L598 696L597 695M635 695L636 696L635 695M598 696L599 697L598 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M633 696L634 697L633 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M599 697L600 698L599 697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M631 697L632 698L631 697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M601 698L602 699L601 698M628 698L629 699L628 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M629 698L630 699L629 698M602 699L603 700L602 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M626 699L627 700L626 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M627 699L628 700L627 699M604 700L605 701L604 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M605 700L606 701L605 700M623 700L624 701L623 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624 700L625 701L624 700M606 701L607 702L606 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M607 701L608 702L607 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M608 701L609 702L608 701M619 701L620 702L619 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M620 701L621 702L620 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M621 701L622 702L621 701M611 702L611 703L616 703L611 702z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseUp);
export default __webpack_public_path__ + "static/media/close-up.f57f4371171dee1f589015dcc3a66ab2.svg";
export { ForwardRef as ReactComponent };